<div class="w-full flex flex-row items-stretch justify-between gap-6 h-fit">
    <div class="flex flex-col items-stretch w-fit">
        <survey-sidebar [class]="sidebarClass" [sectionRoutes]="sidebarSectionRoutes"
            *ngIf="sidebarSectionRoutes.length" [(collapsed)]="sidebarCollapsed" [collapsable]="sidebarCollapsable">
        </survey-sidebar>
    </div>

    <div class="flex flex-row items-stretch transition-all ease-expo duration-500"
        [ngClass]="sidebarSectionRoutes?.length ? (sidebarCollapsed ?'w-[calc(100%-6.5rem)]' :'w-[calc(100%-16.5rem)]') : 'w-full'">
        <ng-content></ng-content>
    </div>
</div>